class APIS {
	apis() {
		return {
			listing: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/products'
			},
			create: {
				headers: {
					'xt-user-token': null,
					'Content-Type': 'application/json'
				},
				method: 'post',
				path: '/product/insert'
			},
			update: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/product/update'
			},
			delete: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/product/delete'
			},
			search: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/product/search'
			}
		};
	}
}

export default new APIS();
